module.exports = __webpack_public_path__ + "img/info.bf9c91bd.jpg";